'use client';

import type { FC, PropsWithChildren } from 'react';
import { createContext, useContext, useMemo } from 'react';

export type TrackingData = Record<string, unknown>;

export interface TrackingDataContextType {
  data?: TrackingData;
}
export const TrackingDataContext = createContext<TrackingDataContextType>({
  data: {},
});

interface Props {
  data?: TrackingData;
}

export type TrackingDataProviderProps = PropsWithChildren<Props>;
export const TrackingDataProvider: FC<TrackingDataProviderProps> = ({ children, data }) => {
  const context = useMemo(
    () => ({
      data,
    }),
    [data],
  );
  return <TrackingDataContext.Provider value={context}>{children}</TrackingDataContext.Provider>;
};

export const useTrackingData = () => useContext(TrackingDataContext);
